import React from 'react'
import { string } from 'prop-types'
import { css } from '@emotion/react'
import { Button } from '@livechat/design-system-react-components'

import {
  getDesignationLabel,
  getDesignationSubscriptionLink,
} from '@/utils/products'
import useParamSelector from '@/hooks/useParamSelector'
import { isPremiumApp, isTeamPlanApp } from '@/store/selectors'
import { PRODUCT, navigateToIFrame } from '@/utils'
import NotInstallableButton from './NotInstallableButton'

const infoCss = css`
  margin-top: 0;
  word-wrap: break-word;
`

const UpgradePlanInfo = ({ designation, id, ...props }) => {
  const subscriptionUrl = getDesignationSubscriptionLink(designation)
  const designationLabel = getDesignationLabel(designation)
  const isPremiumProduct = useParamSelector(isPremiumApp, id)
  const isTeamProduct = useParamSelector(isTeamPlanApp, id)

  const getCopy = (designation) => {
    const isLiveChat = PRODUCT.LiveChat === designation
    switch (true) {
      case isTeamProduct:
        return 'This app is currently available only for Team and higher plans.'
      case isPremiumProduct:
      default:
        return `This app is currently available only for ${
          isLiveChat ? 'Business and Enterprise plans' : 'the Enterprise plan'
        }.`
    }
  }

  const copy = getCopy(designation)

  return (
    <NotInstallableButton {...props}>
      <>
        <p css={infoCss}>{copy}</p>
        <a
          href={subscriptionUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="link"
        >
          <Button
            size="compact"
            kind="primary"
            className="confirm-button"
            fullWidth
            onClick={(e) => navigateToIFrame(e, '/subscription', designation)}
          >
            Upgrade your {designationLabel} plan
          </Button>
        </a>
      </>
    </NotInstallableButton>
  )
}

UpgradePlanInfo.propTypes = {
  designation: string,
  id: string,
}

export default UpgradePlanInfo
